// https://davidwalsh.name/javascript-debounce-function
export var debounceEvent = function( func, wait, immediate ) {
	var timeout;

	return function() {
		var self = this,
			args = arguments;

		var later = function() {
			timeout = null;
			if ( !immediate ) {
				func.apply( self, args );
			}
		};

		var callNow = immediate && !timeout;

		clearTimeout( timeout );
		timeout = setTimeout( later, wait );
		if ( callNow ) {
			func.apply( self, args );
		}
	};
};

